module.exports = __webpack_public_path__ + "b751967cbc60e233d1df8eb41556620b.jpg";